import React from 'react'

import DocumentViewContent from "../components/content/content"

const debug: boolean = false
// const debug: string = "DocumentExportContainer"

type Props = {
    document    : any,
    revisionId? : ID
}

export default class DocumentExportContainer extends React.Component<Props, any> {
    render() {
        debug && console.log(debug, "render", this.props.document)

        return (
            <div className="app-doc-view document-export-container">
                {_.map(this.props.document.pages.models, page=>(
                    <React.Fragment key={page.id}>
                        <DocumentViewContent pageId                 = {page.id}
                                             document               = {this.props.document}
                                             revisionId             = {this.props.revisionId}/>
                        <p style={{pageBreakAfter: 'always'}}>&nbsp;</p>
                    </React.Fragment>
                ))}
            </div>
        )
    }
}